import { PayloadAction } from '@reduxjs/toolkit';

import { MockupState } from 'editor/src/store/mockup/types';

const setMockupDownloadingReducer = (state: MockupState, action: PayloadAction<boolean>) => {
  state.preview.downloading = action.payload;
};

export default setMockupDownloadingReducer;
